import { withMask } from "use-mask-input";
import { validateDob } from "@/utils/validateField/dob";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { useManageInputFields } from "@/pages/quiz/hooks/useManageInputFields";
import { Button, ButtonType } from "@/components/common/button";

type FormFieldName = "dob";
type ContactFieldsValues = Record<FormFieldName, string>;

// Define the validation fields and their properties
const validationFields = {
  dob: {
    customValidator: (v: string) => validateDob(v || ""),
    required: true,
  },
};

const ContactDob = ({
  question,
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<ContactFieldsValues>) => {
  const { registerField, onValidateForm, error } = useManageInputFields(
    {
      setQuestionValue,
      questionValue,
    },
    validationFields
  );

  const isNoErrors = Object.values(error).every(
    (errorMessage) => !errorMessage
  );

  const isAllAnswered =
    Object.values(questionValue).filter(Boolean).length === 1;

  const isFormAnswered = isAllAnswered && isNoErrors;

  const onSubmit = async () => {
    if (isFormAnswered) {
      setQuestionAnswer(questionValue);
    }
  };

  return (
    <>
      <input
        {...registerField("dob")}
        ref={withMask("99/99/9999", {
          jitMasking: true,
          showMaskOnHover: false,
        })}
        inputMode="numeric"
        pattern="[0-9]*"
        placeholder="MM/DD/YYYY"
        className={`
            ${questionValue ? "border-medium-green" : "border-purple"}
            text-lg sm:text-xl lg:text-3xl pb-2 sm:pb-3 lg:pb-4 border-b-4 w-full outline-none text-center placeholder:text-cool-gray transition duration-500
            `}
      />
      {error?.dob && (
        <span className="text-left block mt-2	text-red text-base">
          {error.dob}
        </span>
      )}
      <Button
        type={ButtonType.CONTINUE}
        disabled={!isFormAnswered}
        onClick={onValidateForm(onSubmit)}
      />
    </>
  );
};

export { ContactDob };
